"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SaveRetrieveCartState = /** @class */ (function () {
    function SaveRetrieveCartState() {
        this.showSaveCartModal = false;
        this.showRetrieveCartModal = false;
        this.isEmailinValid = false;
        this.emailErrTxt = '';
        this.emailUpdated = false;
        this.isExistingEmail = false;
        this.isautoTextSelected = false;
        this.isautoEmailSelected = false;
        this.readonlyMode = false;
        this.email = '';
        this.canBeCollapsed = false;
        this.isSubmitBtnDisabled = true;
        this.showCancelAction = false;
        this.showOtherPanelInProgressAlert = false;
        this.showThankyouModalFlag = false;
        this.showSaveCartLink = false;
        this.showRetrieveCartLink = false;
        this.saveCartApiIsError = false;
        this.errorMsgForAuthFlow = false;
    }
    return SaveRetrieveCartState;
}());
exports.default = SaveRetrieveCartState;
//# sourceMappingURL=SaveRetrieveCartState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/cards/SaveRetrieveCart/SaveRetrieveCartState.js
// module id = 2269
// module chunks = 8